module.exports = __webpack_public_path__ + "img/star.a1743878.svg";